<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
      default: '',
      required: false,
    },
    values: {
      type: Array,
    },
    columnWidth: { type: [Number, String], default: -1 },
    isVertical: { type: Boolean, default: false },
    color: { type: [String, Function, Array], default: '#017AFF' },
    scrollOps: {
      type: Object,
      default: null,
      required: false,
    },
    isSyncedScroll: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    topClasses() {
      if (this.isVertical || this.columnWidth === -1) {
        return '';
      }
      if (this.isSyncedScroll) {
        return `is-synced bu-is-${this.columnWidth}`;
      }

      return `bu-is-${this.columnWidth}`;
    },
    effectiveScrollOps() {
      if (this.scrollOps) {
        return this.scrollOps;
      }
      return this.defaultScrollOps;
    },
  },
  methods: {
    getProgressBarEntities(item) {
      return item.bar ? item.bar : [{ color: this.color, percentage: item.percent }];
    },
  },
  data() {
    return {
      defaultScrollOps: {
        vuescroll: {},
        scrollPanel: {
          initialScrollX: false,
        },
        rail: {
          gutterOfSide: '1px',
          gutterOfEnds: '15px',
        },
        bar: {
          background: '#A7AEB8',
          size: '6px',
          specifyBorderRadius: '3px',
          keepShow: false,
        },
      },
    };
  },
});
</script>
<template>
  <div
    class="cly-vue-metric-breakdown bu-column"
    :class="topClasses"
  >
    <cly-section class="cly-vue-metric-breakdown__wrapper">
      <div class="bu-is-relative">
        <div
          v-if="typeof name !== 'undefined'"
          class="bu-level-left bu-p-5"
        >
          <span class="text-medium">{{ name }}</span>
          <span
            v-if="description"
            v-tooltip.top-center="description"
            class="cly-vue-tooltip-icon ion ion-help-circled has-tooltip bu-ml-3"
          />
        </div>
        <div
          v-if="typeof name === 'undefined'"
          class="bu-level-left bu-p-2"
        />
        <div
          v-if="values.length === 0"
          class="bu-pl-3 bu-pr-3 cly-vue-metric-breakdown__empty"
          style="height: 264px;"
        >
          <div>{{ $t('common.table.no-data') }}</div>
        </div>
        <div
          v-else
          class="bu-pl-3 bu-pr-1  cly-vue-metric-breakdown__rows"
          style="height: 264px;"
        >
          <vue-scroll :ops="effectiveScrollOps">
            <div
              v-for="(item, idx) in values"
              :key="idx"
            >
              <div
                :class="{'cly-vue-metric-breakdown__value-row--is-clickable': !!item.link}"
                class="cly-vue-metric-breakdown__value-row bu-p-3"
              >
                <div class="bu-columns cly-vue-metric-breakdown__inner text-medium color-cool-gray-100">
                  <div class="bu-column">
                    <img
                      v-if="item.icon"
                      class="cly-vue-metric-breakdown__row-icon"
                      :src="item.icon"
                    >
                    <span>{{ item.name }}</span>
                  </div>
                  <div class="bu-column cly-vue-metric-breakdown__numbers">
                    <a
                      v-if="item.link"
                      :href="item.link"
                    >
                      <span v-if="item.description">{{ item.description }} | </span>
                      <span>{{ item.percent }} % </span>
                      <i class="fas fa-arrow-circle-right color-cool-gray-40" />
                    </a>
                    <div v-else>
                      <span v-if="item.description">{{ item.description }} | </span>
                      <span>{{ item.percent }} % </span>
                    </div>
                  </div>
                </div>
                <cly-progress-bar
                  :entities="getProgressBarEntities(item)"
                  :height="8"
                />
              </div>
            </div>
          </vue-scroll>
        </div>
        <div class="cly-vue-metric-breakdown__blur_container" />
      </div>
    </cly-section>
  </div>
</template>
